var app = angular.module("leonardo");

var SettingsMapController = function ($scope, AuthDataService, NotificationService, ConfigThemeService, $timeout) {

  $scope.getOptions = function(slider) {
    return {
      floor: 0,
      ceil: 100,
      step: 1,
      noSwitching: true,
      showSelectionBar: true,
      showTicks: true,
      id: 'slider-settings',
      translate: function (value) {
        return value + '%';
      },
      getSelectionBarColor: function () {
        return ConfigThemeService.config.theme_config.warningColor;
      },
      getPointerColor: function() {
        return ConfigThemeService.config.theme_config.secondaryColor;
      },
      getTickColor: function (value) {
        if (value < slider.minValue) {
          return ConfigThemeService.config.theme_config.errorColor;
        }
        else {
          return ConfigThemeService.config.theme_config.successColor;
        }
      }
    };
  };

  $scope.sliderMinor = {
    minValue: AuthDataService.authData.account ? parseFloat(AuthDataService.authData.account.progress_minor_danger) : 0,
    maxValue: AuthDataService.authData.account ? parseFloat(AuthDataService.authData.account.progress_minor_warning) : 0,
  };

  $scope.sliderNormal = {
    minValue: AuthDataService.authData.account ? parseFloat(AuthDataService.authData.account.progress_normal_danger) : 0,
    maxValue: AuthDataService.authData.account ? parseFloat(AuthDataService.authData.account.progress_normal_warning) : 0,
  };

  $scope.sliderCritical = {
    minValue: AuthDataService.authData.account ? parseFloat(AuthDataService.authData.account.progress_critical_danger) : 0,
    maxValue: AuthDataService.authData.account ? parseFloat(AuthDataService.authData.account.progress_critical_warning) : 0,
  };

  $scope.submit = function () {
    if (AuthDataService.authData.account) {
      AuthDataService.authData.account.patch({
        id: AuthDataService.authData.account.id,
        progress_critical_danger: $scope.sliderCritical.minValue,
        progress_critical_warning: $scope.sliderCritical.maxValue,
        progress_normal_danger: $scope.sliderNormal.minValue,
        progress_normal_warning: $scope.sliderNormal.maxValue,
        progress_minor_danger: $scope.sliderMinor.minValue,
        progress_minor_warning: $scope.sliderMinor.maxValue
      }).then(function (data) {
        AuthDataService.authData.account = data;
        NotificationService.notify('success', 'We are refreshing property statistics, the new data will be available in a few moments.');
        $scope.confirm();
      });
    }
    else {
      $scope.confirm();
    }
  };

  $scope.refreshSlider = function () {
    $timeout(function () {
      $scope.$broadcast('rzSliderForceRender');
    });
  };

  function waitForElement(className, callback) {
    var poops = setInterval(function () {
      if (document.getElementsByClassName(className)) {
        clearInterval(poops);
        callback();
      }
    }, 100);
  }

  waitForElement("rzslider", function () {
    $scope.refreshSlider();
  })

};

app.controller('SettingsMapController', ['$scope', 'AuthDataService', 'NotificationService', 'ConfigThemeService', '$timeout', SettingsMapController]);
